export function getDemos() {
    let demos = []
    for (let key in Demos) {
        const demo = Demos[key]
        demos.push({title: demo.name, key: key, value: demo})
    }
    return demos
}

export const Demos = {
    thgr221_mc: {
        name: 'THGR221 MC',
        format: 'OOK',
        rate: 250000,
        timescale: '1us',
        modulation: 'MC',
        warmup_raw: false,
        preamble: 'fffffe',
        preamble_raw: false,
        syncword: false,
        sync_raw: false,
        payload: 'be28512a95880d82e453fffffebe28512a95880d82e453fffffebe28512a95880d82e452',
        payload_invert: false,
        postamble: false,
        postamble_raw: false,
        short: 500,
        gap: 0,
        repeat: 1,
        jitter: 5,
    },
    vailant_dm: {
        name: 'Vailant DM',
        format: 'OOK',
        rate: 250000,
        timescale: '1us',
        modulation: 'DM',
        warmup_raw: false,
        preamble: false,
        preamble_raw: false,
        syncword: false,
        sync_raw: false,
        payload: '{130}ffff814990fffbfffffed2ff4136807fc', // last byte is only 2 bits
        //payload: [0xff, 0xff, 0x81, 0x49, 0x90, 0xff, 0xfb, 0xff, 0xff, 0xfe, 0xd2, 0xff, 0x41, 0x36, 0x80, 0x7f, 0xc0], // last byte is only 2 bits
        //payload: [0xff, 0xff, 0x81, 0x49, 0x90, 0xff, 0xfb, 0xff, 0x7f, 0xfe, 0xd2, 0xff, 0x41, 0x76, 0x80, 0x7f, 0xc0], // last byte is only 2 bits
        payload_invert: false,
        postamble: false,
        postamble_raw: [0, 16764],
        short: 830,
        gap: 0,
        repeat: 2,
        jitter: 10,
    },
    fody_pcm: {
        name: 'Fody PCM (NRZ)',
        format: 'FSK',
        rate: 250000,
        timescale: '1us',
        modulation: 'PCM',
        warmup_raw: false,
        preamble: '00aaaaaaaaaa',
        preamble_raw: false,
        syncword: '2dd4',
        sync_raw: false,
        payload: 'f4f5edffffffffffedc8ffffff0b0a12000000000012370000000000',
        payload_invert: false,
        postamble: false,
        postamble_raw: false,
        short: 488,
        long: false,
        gap: 0,
        repeat: 1,
        jitter: 4,
    },
    pcm_rz: {
        name: 'PCM (RZ) test',
        format: 'OOK',
        rate: 250000,
        timescale: '1us',
        modulation: 'PCM',
        warmup_raw: false,
        preamble: 'aaaaaaa9',
        preamble_raw: false,
        syncword: false,
        sync_raw: false,
        payload: 'a0ff',
        payload_invert: false,
        postamble: false,
        postamble_raw: false,
        short: 500,
        long: 1000,
        gap: 0,
        repeat: 1,
        jitter: 10,
    },
    proove_ppm: {
        name: 'Proove PPM',
        format: 'OOK',
        rate: 250000,
        timescale: '1us',
        modulation: 'PPM',
        warmup_raw: false,
        preamble: false,
        preamble_raw: [280, 2600],
        syncword: false,
        sync_raw: false,
        payload: '59A6A9AA66666955',
        payload_invert: false,
        postamble: false,
        postamble_raw: false,
        pulse: 260,
        short: 270,
        long: 1300,
        gap: 10000,
        repeat: 15,
        jitter: 0.05,
    },
    bresser3ch_pwm: {
        name: 'Bresser-3ch PWM',
        format: 'OOK',
        rate: 250000,
        timescale: '1us',
        modulation: 'PWM',
        warmup_raw: false,
        preamble: false,
        preamble_raw: [750, 700, 750, 700, 750, 700, 750, 700],
        syncword: false,
        sync_raw: false,
        payload: 'e8d9f3bf76',
        payload_invert: false,
        postamble: false,
        postamble_raw: false,
        short: 260,
        long: 500,
        sync: 750,
        short_gap: 470,
        long_gap: 227,
        gap: 1000,
        repeat: 15,
        jitter: 0.05,
    },
    pwm_fixedgap: {
        name: 'PWM (fixed gap) test',
        format: 'OOK',
        rate: 250000,
        timescale: '1us',
        modulation: 'PWM',
        warmup_raw: false,
        preamble: 'aaaaaaa9',
        preamble_raw: false,
        syncword: false,
        sync_raw: false,
        payload: 'a0ff',
        payload_invert: false,
        postamble: false,
        postamble_raw: false,
        short: 500,
        long: 1000,
        short_gap: 500,
        long_gap: 500,
        gap: 0,
        repeat: 1,
        jitter: 0.05,
    },
    klimalogg_nrzi: {
        name: 'Klimalogg NRZI',
        format: 'OOK',
        rate: 250000,
        timescale: '1us',
        modulation: 'NRZI',
        warmup_raw: false,
        preamble: '067ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffe',
        preamble_raw: false,
        syncword: false,
        sync_raw: false,
        payload: '619fe6600fffc3c333fcffcff30fffc3ffffc33333fcffffffffff8007e0',
        payload_invert: false,
        postamble: false,
        postamble_raw: [0, 10000],
        short: 12,
        long: false,
        gap: 0,
        repeat: 1,
        jitter: 2,
    },
}
